exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.no-text-decoration[data-v-8592400a] {\n    text-decoration: none;\n}\n", ""]);
